const baseUrl = '/api/customer/post'

export default {
    list: (opt) => {
        opt = {
            search: null,
            freeContent: null,
            userId: null,
            page_size: null,
            page: 1,
            ...opt,
        }

        const toQs = ['search', 'freeContent', 'userId', 'page_size', 'page']
        const qs = toQs.filter(k => opt[k]).map(k => `${k}=${encodeURIComponent(opt[k])}`).join('&')

        return axios.get(`${baseUrl}${qs ? `?${qs}` : ''}`)
    },

    count: (opt) => {
        opt = {
            search: null,
            freeContent: null,
            userId: null,
            ...opt,
        }

        const toQs = ['search', 'freeContent', 'userId']
        const qs = toQs.filter(k => opt[k]).map(k => `${k}=${encodeURIComponent(opt[k])}`).join('&')

        return axios.get(`${baseUrl}/count${qs ? `?${qs}` : ''}`)
    },

    get: (id) => {
        return axios.get(`${baseUrl}/${id}`)
    },

    store: (description, fileIds, locker, schedule) => {
        const data = {
            content: {
                description,
                locker,
            },
            schedule_options: schedule,
            fileIds,
        }

        return axios.post(baseUrl, data)
    },

    update: (id, description, fileIds, locker, schedule) => {
        const data = {
            content: {
                description,
                locker,
            },
            schedule_options: schedule,
            fileIds,
        }

        return axios.put(`${baseUrl}/${id}`, data)
    },

    delete: (id) => {
        return axios.delete(`${baseUrl}/${id}`)
    },
}
